module.exports = __webpack_public_path__ + "static/slide5-big-data-flipped-812a7427f96abed0276e885ea776d781.jpg";